module.exports = __webpack_public_path__ + "img/effectiveness.d67a62ad.png";